import { useRouter } from "vue-router";
import { reloadAppAtPath } from "@/router/utils";

export function useChunkPreloadErrorHandling() {
  const router = useRouter();

  const chunkErrors = new Set<Error>();
  router.beforeEach(() => {
    chunkErrors.clear();
  });

  window.addEventListener("vite:preloadError", event => {
    chunkErrors.add(event.payload);
  });

  if (import.meta.env.PROD) {
    router.onError((error, to) => {
      if (chunkErrors.has(error)) {
        reloadAppAtPath(to);
      }
    });
  }
}
